import React, { useContext } from 'react'
import CommonBox from './components/CommonBox'
import GifImagesSection from './components/GifImagesSection'
import WriteCustomerCenterSection from './components/WriteCustomerCenterSection'

const WriteCustomerCenter = () => {

    return (
        <>
            <section className='write-customer-center-section'>
                <CommonBox heading="고객센터" englishHeading="customer center" isEnglishHeadingOnMobile={true} isAuthenticated={true}>
                    <WriteCustomerCenterSection />
                </CommonBox>
            </section>
            <section className='gif-section flex lg:hidden items-center justify-center'>
                <GifImagesSection />
            </section>
        </>
    )
}

export default WriteCustomerCenter